// src/components/ResultSummary/ResultSummary.tsx
import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './ResultSummary.scss';
import { formatCurrency } from '../../../../../../../../../../utils/functions';

interface ResultSummaryProps {
  result: any;
}

const CollapsibleSection: React.FC<{ title: string; count: number; children: React.ReactNode }> = ({ title, count, children }) => {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div className="summary-section">
            <div className="section-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{title}</span>
                <div className="header-right">
                    <span className="count-badge">{count}</span>
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
            </div>
            {isOpen && <div className="section-body">{children}</div>}
        </div>
    );
};

const ResultSummary: React.FC<ResultSummaryProps> = ({ result }) => {
  const { execute_phase, finalize_phase } = result;

  return (
    <div className="result-summary-step">
      <div className="summary-provider-card">
        <h5>Proveedor Procesado</h5>
        <p><strong>Nombre:</strong> {execute_phase.provider.name}</p>
        <p><strong>RUT:</strong> {execute_phase.provider.rut}</p>
      </div>

      <CollapsibleSection title="Ingredientes Creados/Encontrados" count={execute_phase.ingredients.length}>
        <Table responsive hover size="sm">
          <thead><tr><th>ID</th><th>Nombre</th></tr></thead>
          <tbody>
            {execute_phase.ingredients.map((ing: any) => (
              <tr key={ing.ingredient_id}><td>{ing.ingredient_id}</td><td>{ing.name}</td></tr>
            ))}
          </tbody>
        </Table>
      </CollapsibleSection>
      
      <CollapsibleSection title="Marcas Creadas/Encontradas" count={execute_phase.brands.length}>
        <Table responsive hover size="sm">
          <thead><tr><th>ID</th><th>Nombre</th></tr></thead>
          <tbody>
            {execute_phase.brands.map((br: any) => (
              <tr key={br.brand_id}><td>{br.brand_id}</td><td>{br.name}</td></tr>
            ))}
          </tbody>
        </Table>
      </CollapsibleSection>

      <CollapsibleSection title="Actualizaciones de Stock" count={execute_phase.stock_updates.length}>
        <Table responsive hover size="sm">
          <thead><tr><th>ID Ingrediente</th><th>Antes</th><th>Después</th><th>Almacén</th></tr></thead>
          <tbody>
            {execute_phase.stock_updates.map((u: any) => (
              <tr key={u.ingredient_id}><td>{u.ingredient_id}</td><td>{u.old_quantity}</td><td>{u.new_quantity}</td><td>{u.storage_unit_id}</td></tr>
            ))}
          </tbody>
        </Table>
      </CollapsibleSection>

      <CollapsibleSection title="Compras Registradas" count={finalize_phase.purchases_created.length}>
        <Table responsive hover size="sm">
          <thead><tr><th>ID Ingrediente</th><th>Cantidad</th><th>Total Neto</th><th>ID Marca</th></tr></thead>
          <tbody>
            {finalize_phase.purchases_created.map((p: any, i: number) => (
              <tr key={i}>
                <td>{p.ingredient_id}</td>
                <td>{p.quantity}</td>
                <td>{formatCurrency(p.total_neto)}</td>
                <td>{p.brand_id != null ? p.brand_id : <span className="no-data-badge">N/A</span>}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CollapsibleSection>
    </div>
  );
};

export default ResultSummary;
